module.exports = __webpack_public_path__ + "static/img/行销-2.0105d10a.png";